import React, {useState} from "react";
import {Dialog} from "@material-ui/core";
import {Form, Formik} from "formik";
import "./index.scss"
import {Button} from "../../Button";
import {smartDriveCheck} from "../../../api/smartDriveApiClient";
import {strings} from "../../../strings/strings";
import {InputTextMask} from "../../inputs/InputTextMask";
import {FormItem} from "../../inputs/FormItem";


export const PhoneAskDialog = ({open, noSmartDriveListener, onPhoneSubmit}) => {
    const [process, setProcess] = useState(false);

    return (
        <Dialog open={open} disableBackdropClick={true}>
            <div className={"dialog"}>
                <Formik
                    initialValues={{
                        phone: ''
                    }}
                    onSubmit={values => {
                        onPhoneSubmit(values);
                    }}
                    validateOnBlur={false}
                    validateOnChange={false}
                    validate={values => {
                        setProcess(true);
                        const errors: any = {};
                        return smartDriveCheck(values.phone).then(r => {
                            if (r.userExists !== true) {
                                errors.phone = strings.smartDrive.askPhone.error;
                            }
                            return errors;
                        }).finally(() => {
                            setProcess(false);
                        });
                    }}
                >
                    {formProps => (
                        <Form>
                            <div className={"dialog__content"}>
                                <span className={"dialog__title"}>{strings.important}</span>

                                <p className={"dialog__message"}>
                                    {strings.sdEnterNumberPhone}
                                </p>

                                <FormItem name={'phone'} validation={{ isRequired: true }}>
                                    <InputTextMask
                                        label={strings.personalInfoLivingPhone}
                                        mask={"+38(999)999-99-99"}
                                    />
                                </FormItem>


                                <Button label={strings.buyMTPLDlg.btnNext}
                                        id={'buyMTPLDlg-btnNext'}
                                        isProcess={process}
                                        onClickListener={formProps.handleSubmit}/>

                                <Button label={strings.buyMTPLDlg.btnHaveNot} variant={"link"}
                                        id={'buyMTPLDlg-btnHaveNot'}
                                        onClickListener={noSmartDriveListener}/>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Dialog>
    )

}
